




import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "qPriceFormatted",
})
export default class QPriceFormatted extends Vue {
  @Prop({
    required: true,
  })
  public price: boolean;

  public moneyFormatter(price) {
    const options = {
      maximumSignificantDigits: 10,
    };

    return new Intl.NumberFormat("ja-JP", options).format(price);
  }
}
